// Inline confirmation card shown when a tool-call carries a safety_check.
// Renders the reason + Allow/Deny buttons that call controller.resolveConfirm.
//
// Status handling: prefer `status.type === "requires-action"`. If assistant-ui
// does not route that status through ExternalStoreRuntime, fall back to
// detecting `args._safetyCheck` + absence of `result`.

import React from "react";
import { ShieldAlert } from "lucide-react";

export function SafetyConfirmAction({ toolCallId, args, status, result, controller }) {
  const requiresAction =
    status?.type === "requires-action" || (args?._safetyCheck && !result);

  if (!requiresAction) return null;

  const reason =
    args?._safetyCheck?.reason || "This action may be sensitive or irreversible.";

  return (
    <div
      role="alertdialog"
      aria-label="Confirm action"
      className="tw-my-1 tw-flex tw-flex-col tw-gap-2 tw-rounded-lg tw-border tw-border-accent/60 tw-bg-accent/10 tw-p-2.5 tw-text-xs tw-text-foreground"
    >
      <div className="tw-flex tw-items-start tw-gap-2">
        <ShieldAlert className="tw-mt-0.5 tw-h-4 tw-w-4 tw-shrink-0 tw-text-accent" />
        <p className="tw-flex-1 tw-leading-snug">{reason}</p>
      </div>
      <div className="tw-flex tw-gap-2">
        <button
          type="button"
          onClick={() => controller.resolveConfirm(toolCallId, "allowed")}
          className="tw-flex-1 tw-rounded-md tw-bg-emerald-600 tw-px-3 tw-py-1 tw-text-xs tw-font-semibold tw-text-white tw-transition hover:tw-bg-emerald-700"
        >
          Allow
        </button>
        <button
          type="button"
          onClick={() => controller.resolveConfirm(toolCallId, "denied")}
          className="tw-flex-1 tw-rounded-md tw-bg-card tw-px-3 tw-py-1 tw-text-xs tw-font-semibold tw-text-card-foreground tw-transition hover:tw-bg-muted"
        >
          Deny
        </button>
      </div>
    </div>
  );
}
